var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"content has-text-centered"},[_c('p',[_vm._v("\n      © "+_vm._s(new Date().getFullYear())+" Cloudprinter.com B.v.\n      ")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }